import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DialogHeader","DialogTitle","DialogDescription","Dialog","DialogTrigger","DialogContent"] */ "/vercel/path0/src/components/ui/dialog.tsx");
